// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationLockDto
 */
export interface IOrganizationLockDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationLockDto
     */
    organization_id: number;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationLockDto
     */
    is_locked: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationLockDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationLockDto
     */
    has_replenished_accounts?: boolean;
}

/**
 * Check if a given object implements the IOrganizationLockDto interface.
 */
export function instanceOfIOrganizationLockDto(value: object): value is IOrganizationLockDto {
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('is_locked' in value) || value['is_locked'] === undefined) return false;
    return true;
}

export function IOrganizationLockDtoFromJSON(json: any): IOrganizationLockDto {
    return IOrganizationLockDtoFromJSONTyped(json, false);
}

export function IOrganizationLockDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationLockDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'is_locked': json['is_locked'],
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'has_replenished_accounts': json['has_replenished_accounts'] == null ? undefined : json['has_replenished_accounts'],
    };
}

export function IOrganizationLockDtoToJSON(json: any): IOrganizationLockDto {
    return IOrganizationLockDtoToJSONTyped(json, false);
}

export function IOrganizationLockDtoToJSONTyped(value?: IOrganizationLockDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'is_locked': value['is_locked'],
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'has_replenished_accounts': value['has_replenished_accounts'],
    };
}

